var map = {
	"./Authentication/ForgotPassword.js": 220,
	"./Authentication/Login.js": 285,
	"./Authentication/Logout.js": 234,
	"./Authentication/Register.js": 235,
	"./Brand.js": 236,
	"./Campaign.js": 241,
	"./Cart.js": 243,
	"./Category.js": 244,
	"./Collection.js": 245,
	"./Collections.js": 256,
	"./Discover.js": 257,
	"./Home.js": 258,
	"./Invoice.js": 259,
	"./Invoices.js": 260,
	"./MyProfile.js": 261,
	"./NewProducts.js": 262,
	"./NotFound.js": 143,
	"./Order.js": 263,
	"./Orders.js": 264,
	"./Payment.js": 287,
	"./Payment/CreatePayment.js": 288,
	"./Payment/FailCallback.js": 268,
	"./Payment/SuccessCallback.js": 269,
	"./Print/PrintCollection.js": 270,
	"./Print/PrintCollections.js": 271,
	"./Print/PrintOrder.js": 272,
	"./Print/PrintOrders.js": 273,
	"./Product.js": 286,
	"./ProductReport.js": 277,
	"./ProductReportDetail.js": 278,
	"./Profile.js": 279,
	"./ResetPassword.js": 280,
	"./Search.js": 281
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 219;